// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/custom_work_action.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_custom_action_effect } from "./custom_action_effect_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/custom_work_action.proto.
 */
export const file_studyo_today_planners_v1_resources_custom_work_action = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2N1c3RvbV93b3JrX2FjdGlvbi5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJpChBDdXN0b21Xb3JrQWN0aW9uEg0KBWxhYmVsGAEgASgJEkYKBmVmZmVjdBgCIAEoDjI2LnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuQ3VzdG9tQWN0aW9uRWZmZWN0QiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_planners_v1_resources_custom_action_effect]);

/**
 * Describes the message studyo.today.planners.v1.resources.CustomWorkAction.
 * Use `create(CustomWorkActionSchema)` to create a new message.
 */
export const CustomWorkActionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_custom_work_action, 0);

